export const endpoints = {
  externalUrlGroupItem: 'externalUrlGroup',
  externalUrlOptions: 'externalUrlGroup/externalUrl/options',
  languageOptions: 'externalUrl/language/options',
  caseTypeOptions: 'externalUrlGroup/operationaccess/application/options',
  operationOptions: (applicationId: string) =>
    `externalUrlGroup/operationaccess/application/${applicationId}/operation/options`
};
